<template>
  <nav class="breadcrumb" aria-label="breadcrumb">
    <ol class="breadcrumb-list">
      <li 
        v-for="(item, index) in breadcrumbItems" 
        :key="index"
        class="breadcrumb-item"
        :class="{ 'active': index === breadcrumbItems.length - 1 }"
      >
        <router-link 
          v-if="index < breadcrumbItems.length - 1" 
          :to="item.to"
          class="breadcrumb-link"
        >
          {{ item.label }}
        </router-link>
        <span v-else class="breadcrumb-current">
          {{ item.label }}
        </span>
        <span v-if="index < breadcrumbItems.length - 1" class="breadcrumb-separator">/</span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return items.every(item => 
          Object.prototype.hasOwnProperty.call(item, 'label') && 
          (Object.prototype.hasOwnProperty.call(item, 'to') || items.indexOf(item) === items.length - 1)
        );
      }
    }
  },
  computed: {
    breadcrumbItems() {
      // Always start with Home
      const items = [
        {
          label: this.$t ? this.$t('Breadcrumb.home') : 'ראשי',
          to: { name: 'Products' }
        }
      ];
      
      // Add the provided items
      return [...items, ...this.items];
    }
  }
};
</script>

<style scoped lang="scss">
.breadcrumb {
  padding: 0;
  
  .breadcrumb-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 8px;
  }
  
  .breadcrumb-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    
    &.active {
      .breadcrumb-current {
        color: #666;
        font-weight: 500;
      }
    }
  }
  
  .breadcrumb-link {
    color: $primaryColor;
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: darken($primaryColor, 10%);
      text-decoration: underline;
    }
  }
  
  .breadcrumb-current {
    color: #666;
  }
  
  .breadcrumb-separator {
    margin: 0 8px;
    color: #999;
    user-select: none;
  }
}

.isMobile {
  .breadcrumb {
    margin: 0 0 15px 0;
    
    .breadcrumb-item {
      font-size: 12px;
    }
    
    .breadcrumb-separator {
      margin: 0 4px;
    }
  }
}
</style>
